import { Navigate } from "react-router-dom";

function App() {
  const userStr = localStorage.getItem("user");
  let user = null;
  
  try {
    user = userStr ? JSON.parse(userStr) : null;
  } catch (e) {
    console.error("Error parsing user from localStorage:", e);
    localStorage.removeItem("user");
    return <Navigate to="/login" />;
  }

  if (user && user?.token) {
    const email = (user.email || "").toLowerCase().trim();

    // Explicit delivery login → delivery module (overrides API role if mismatched)
    let userRole =
      email === "delivery@gmail.com" ? "order_deliver" : user.user_role;

    // Fallback: determine role from email if user_role is not set
    if (!userRole && email) {
      if (email.includes("admin")) {
        userRole = "admin";
      } else if (email.includes("reception")) {
        userRole = "reception";
      } else if (email.includes("kitchen")) {
        userRole = "kitchen";
      } else if (email.includes("deliver") || email.includes("delivery")) {
        userRole = "order_deliver";
      } else {
        // Default to reception if role cannot be determined
        userRole = "reception";
      }
    }
    
    // Redirect based on role
    if (userRole === "kitchen") {
      return <Navigate to="/kitchen" />;
    } else if (userRole === "reception" || userRole === "admin") {
      return <Navigate to="/reception" />;
    } else if (userRole === "order_deliver") {
      return <Navigate to="/deliverymodule" />;
    } else {
      // Default fallback to reception
      return <Navigate to="/reception" />;
    }
  } else {
    return <Navigate to="/login" />;
  }
}

export default App;
